module.exports = __webpack_public_path__ + "static/media/Savory.808d12a2.jpg";